// extracted by mini-css-extract-plugin
export var checkbox = "_33-0";
export var circle = "_33-3";
export var horizontalContainer = "_33-7";
export var sm = "_33-5";
export var switch0 = "_33-2";
export var switchDisabled = "_33-8";
export var switchEnabled = "_33-1";
export var textSwitchContainer = "_33-9";
export var textSwitchOption = "_33-a";
export var textSwitchOptionSelected = "_33-b";
export var verticalContainer = "_33-6";
export var xs = "_33-4";